import React from 'react';

import {
  Section,
  CardHeader,
  Card,
  CardContent,
  Actions,
  Action,
  EditIcon,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import { BusinessPartnerFormEdit } from 'scenes/BusinessPartners/components/BusinessPartnerForm';
import BusinessPartnerContactDetails from 'scenes/IO/components/BusinessPartnerContactDetails';

const BusinessPartnerDetails = ({
  data,
  bpId,
  reload,
  isEditable,
  disabled,
} = {}) => {
  const [childComponent, openChildComponent] = useChildComponent();
  const handleEdit = () => {
    openChildComponent(BusinessPartnerFormEdit, {
      id: bpId,
      onSubmit: () => reload(),
      granularity: 'businessPartnerDetails',
    });
  };

  return (
    <Section>
      <Card elevation={6}>
        <CardHeader
          title={'Business Partner Contact Details'}
          action={
            <Actions>
              <Action
                icon={<EditIcon />}
                label={'Edit'}
                onClick={handleEdit}
                disabled={!isEditable || disabled}
              />
            </Actions>
          }
        />
        <CardContent>
          <BusinessPartnerContactDetails data={data} />
          {childComponent}
        </CardContent>
      </Card>
    </Section>
  );
};

export default BusinessPartnerDetails;
